import React from 'react';
import { Link } from 'react-router-dom';
import { Headphones } from 'lucide-react';
import LoginForm from '@/components/auth/LoginForm';

const LoginPage: React.FC = () => {
  return (
    <div
      className="cc-aurora relative px-4"
      style={{ minHeight: '100vh', paddingTop: '0px', paddingBottom: '16px' }}
    >
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-0 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(91,124,255,0.18),transparent_70%)] blur-2xl animate-float" />

      <div
        className="relative z-10 mx-auto w-full max-w-[420px]"
        style={{ position: 'absolute', top: '64px', left: '50%', transform: 'translateX(-50%)', width: 'calc(100% - 32px)' }}
      >
        <div className="mb-4 mt-0 flex items-center justify-center gap-3">
          <Headphones className="h-7 w-7 text-fg-secondary" />
          <span className="cc-display text-[32px] font-extrabold leading-none text-fg-primary">
            Club<span className="cc-grad-text">:</span>Core
          </span>
        </div>

        <LoginForm />

        <Link
          to="/"
          className="mt-3 block text-center text-sm text-fg-muted transition-colors hover:text-fg-primary"
        >
          ← Вернуться на главную
        </Link>
      </div>

      {/* Info-блок снизу — заполняет пустое пространство. Статус систем,
          quick-stats и copyright. Position-fixed чтобы не зависел от
          высоты карточки выше. */}
      <div
        style={{ position: 'fixed', left: 0, right: 0, bottom: 0, paddingBottom: '14px', pointerEvents: 'none' }}
        className="px-4"
      >
        <div className="mx-auto w-full max-w-[420px]" style={{ pointerEvents: 'auto' }}>
          {/* Статус-пилюля */}
          <div className="mb-3 flex justify-center">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-line bg-bg-card px-3 py-1 text-[10.5px] font-semibold uppercase tracking-[0.18em] text-fg-muted">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-400" />
              </span>
              Все системы в норме
            </span>
          </div>

          {/* Три мини-факта */}
          <div className="grid grid-cols-3 gap-2">
            {[
              { label: 'Ответ', value: 'за минуты' },
              { label: 'Каналы', value: '6+' },
              { label: 'Поддержка', value: '24/7' },
            ].map((it) => (
              <div
                key={it.label}
                className="rounded-xl border border-line bg-bg-card px-2 py-2 text-center"
              >
                <div className="text-[10px] font-semibold uppercase tracking-[0.12em] text-fg-muted">
                  {it.label}
                </div>
                <div className="mt-0.5 text-[12.5px] font-bold text-fg-primary">
                  {it.value}
                </div>
              </div>
            ))}
          </div>

          {/* Copyright */}
          <p className="mt-3 text-center text-[10.5px] text-fg-muted">
            Club:Core · Support Portal · {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
